export default function Spinner({huge, big, noSize, className})
{
  return <div className={`${huge ? 'w-24 h-24 border-8' : big ? 'w-8 h-8 border-4' : (noSize || 'w-4 h-4 border-2')} rounded-full animate-spin border-l-transparent border-r-current border-t-current border-b-current dark:border-r-current dark:border-t-current dark:border-b-current ${className}`} />;
}
